import axios from "@/app/http/axiosAuth";
import { ApiEndpoint } from "@/app/apiEndpoint";
import { useUserProfileStore } from "@/store/userProfile";
import { IUserProfile } from "@/interface/UserProfile.interface";
import { useMenuStore } from "@/store/menu";
import { MENU_ID, PERMISSION_CODE, USER_TYPE } from "@/app/menu";
import { menuItems } from "@/components/layouts/utils";
import appConfigs from "@/app/appConfigurations";

export default class UserService {
  editProfileUrl = appConfigs.edit_profile as string;
  userInfo = undefined as IUserProfile | undefined;
  userMenuKeys = [
    MENU_ID.Home,
    // MENU_ID.FlightStatus,
    MENU_ID.Complaint,
    MENU_ID.ComplaintStatus,
  ];
  ascMenuKeys = [MENU_ID.ComplaintOcpb, MENU_ID.ComplaintOpm];

  constructor() {}

  updateUserInfo() {
    const stateUserProfile = useUserProfileStore();
    stateUserProfile.loadProfile();
    this.userInfo = stateUserProfile.profile;
  }

  currentUserInfo(): IUserProfile | undefined {
    if (this.userInfo === undefined) {
      this.updateUserInfo();
    }
    return this.userInfo;
  }

  currentDepartment(): string | undefined {
    return this.currentUserInfo()?.department;
  }

  addMenuAccessible(value: string[]) {
    const menuStore = useMenuStore();
    let menues = menuStore.getData() ?? [];
    value.forEach((v) => {
      if (!menues.includes(v)) {
        menues.push(v);
      }
    });
    menuStore.setData(menues);
    return menues;
  }
  menuAccessibles() {
    const menuStore = useMenuStore();
    const data = menuStore.getData() ?? [];
    if (data.length === 0) {
      this.filterMenuByPermission();
    }
    return menuStore.getData() ?? [];
  }

  isAsc(): boolean {
    const userInfo = this.currentUserInfo();
    if (!userInfo) return false;
    return (
      userInfo.userType === USER_TYPE.Internal &&
      userInfo.permissionCode.includes(PERMISSION_CODE.ASCManageReq)
    );
  }
  isDpm(): boolean {
    const userInfo = this.currentUserInfo();
    if (!userInfo) return false;
    return userInfo.userType === USER_TYPE.Internal && !this.isAsc();
  }
  isUser(): boolean {
    return (
      this.currentUserInfo()?.userType === USER_TYPE.External &&
      (this.currentUserInfo()?.permissionCode?.includes(PERMISSION_CODE.User) ??
        false)
    );
  }
  isAirline() {
    return this.currentUserInfo()?.userType === USER_TYPE.StakeHolder;
  }
  isAdminERD() {
    const userInfo = this.currentUserInfo();
    if (!userInfo) return false;
    return userInfo.permissionCode.includes(PERMISSION_CODE.AdminERD);
  }
  isLoggedIn() {
    return (
      this.currentUserInfo() !== undefined && this.currentUserInfo()?.id !== 0
    );
  }

  async getUserByUsername(username: string) {
    try {
      const response = await axios.get(
        `${ApiEndpoint.UserInfo.GET_USR_INFO_BY_USERNAME.replace(
          ":username",
          username
        )}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  filterMenuByPermission() {
    const permissionCodes = this.currentUserInfo()?.permissionCode ?? [];
    const userType = this.currentUserInfo()?.userType;
    let menuFiltered = [...menuItems];
    // if user internal or stake holder
    if (userType === USER_TYPE.Internal || userType === USER_TYPE.StakeHolder) {
      // if not asc -> remove user's menu & remove ocpb & remove opm
      if (!(userType === USER_TYPE.Internal && this.isAsc())) {
        menuFiltered = menuFiltered.filter(
          (menuItem) => !this.userMenuKeys.includes(menuItem.id)
        );
        menuFiltered = menuFiltered.filter(
          (menuItem) => !this.ascMenuKeys.includes(menuItem.id)
        );
      }
      // if not admin -> remove admin's menu
      if (!permissionCodes.includes(PERMISSION_CODE.Admin)) {
        menuFiltered = menuFiltered.filter(
          (menuItem) => menuItem.id !== MENU_ID.Admin
        );
        if (!this.isAdminERD()) {
          // menuFiltered = menuFiltered.filter(
          //   (menuItem) => menuItem.id !== MENU_ID.AdminFlight
          // );
        }
      } else {
        // if (!this.isAdminERD()) {
        // menuFiltered = menuFiltered.filter(
        //   (menuItem) => menuItem.id !== MENU_ID.AdminFlight
        // );
        // }
      }
    } else if (userType === USER_TYPE.External) {
      menuFiltered = menuFiltered.filter(
        (menuItem) =>
          menuItem.id !== MENU_ID.Admin &&
          menuItem.id !== MENU_ID.ComplaintList &&
          // && menuItem.id !== MENU_ID.AdminFlight
          menuItem.id !== MENU_ID.ComplaintOcpb &&
          menuItem.id !== MENU_ID.ComplaintOpm
      );
    }
    this.addMenuAccessible([MENU_ID.Complaint]);
    this.addMenuAccessible(menuFiltered.map((o) => o.id));
    return menuFiltered;
  }
}
